export const formatDecimal = (value: number | null | undefined, digits = 1): string | null => {
  if (value == null || Number.isNaN(value)) {
    return null;
  }
  return value.toFixed(digits);
};
